module.exports = __webpack_public_path__ + "img/m-min.2e5f850c.webp";